<template>
  <div class="d-flex align-center">
    <div class="container__flag-cards">
      <img
        v-if="flagSvg"
        :src="flagSvg"
        alt="country flag"
        class="flag"
        :class="{ couple: couple }"
      />
    </div>
    <div class="ml-2" v-if="items.length > 1">
      <span style="font-size: 12px">+{{ items.length - 1 }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlagCards',
  props: {
    items: {
      type: Array,
      required: true,
    },
    couple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      flagSvg: null,
    }
  },
  async created() {
    try {
      const flagMap = {
        br: require('@/assets/brazil.svg'),
        us: require('@/assets/english.svg'),
        it: require('@/assets/italy.svg'),
        es: require('@/assets/spanish.svg'),
        fr: require('@/assets/france.svg'),
        de: require('@/assets/germany.svg'),
        ru: require('@/assets/russia.svg'),
        nl: require('@/assets/netherlands.svg'),
        pl: require('@/assets/poland.svg'),
        in: require('@/assets/india.svg'),
        tr: require('@/assets/turkey.svg'),
        id: require('@/assets/indonesia.svg'),
        bg: require('@/assets/bulgaria.svg'),
        ro: require('@/assets/romania.svg'),
        cz: require('@/assets/czech-republic.svg'),
        gr: require('@/assets/greece.svg'),
        fi: require('@/assets/finland.svg'),
        hr: require('@/assets/croatia.svg'),
        sk: require('@/assets/slovakia.svg'),
        jp: require('@/assets/japan.svg'),
        ua: require('@/assets/ukraine.svg'),
        kr: require('@/assets/south-korea.svg'),
        se: require('@/assets/sweden.svg'),
        no: require('@/assets/norway.svg'),
        rs: require('@/assets/serbia.svg'),
        hu: require('@/assets/hungary.svg'),
        sa: require('@/assets/saudi-arabia.svg'),
        th: require('@/assets/thailand.svg'),
        vn: require('@/assets/vietnam.svg'),
        cn: require('@/assets/china.svg'),
        ke: require('@/assets/kenya.svg'),
        my: require('@/assets/malaysia.svg'),
      }

      const countryCode = this.items[0] || null

      if (countryCode && flagMap[countryCode]) {
        const svgUrl = flagMap[countryCode]
        const response = await fetch(svgUrl)
        const svgText = await response.text()

        const base64Svg = `data:image/svg+xml;base64,${btoa(svgText)}`
        this.flagSvg = base64Svg
      }else{
        console.log('FlagCards countryCode:', countryCode)

      }
    } catch (error) {
      console.error('Error loading flag SVG:', error)
    }
  },
}
</script>

<style lang="scss" scoped>
.container__flag-cards {
  display: flex;
  height: 16px;
}
.flag {
  display: block;
  opacity: 0;
  height: 16px;
  width: 16px;
  transition: opacity 0.3s ease-in-out;
}
.flag[alt='country flag'] {
  opacity: 1;
}
</style>
